import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export default function InstallPWA() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem("pwa-dismissed") === "1") return;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIOS()) setShow(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => { setShow(false); setIosHint(false); localStorage.setItem("pwa-dismissed", "1"); };

  const install = async () => {
    if (isIOS()) { setIosHint(true); return; }
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") setShow(false);
    setDeferred(null);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-safe-5 left-5 z-[60] max-w-[300px]" data-testid="install-pwa">
      {iosHint ? (
        <div className="rounded-xl border border-border bg-card shadow-2xl p-4 text-sm" data-testid="install-ios-hint">
          <div className="flex items-start justify-between gap-2 mb-2">
            <strong className="font-head">Ana ekrana ekle</strong>
            <button onClick={dismiss} data-testid="install-close"><X size={16} className="text-muted-foreground" /></button>
          </div>
          <p className="text-muted-foreground leading-snug">
            Safari'de alttaki <Share size={13} className="inline -mt-0.5" /> <strong>Paylaş</strong> düğmesine dokunun, ardından
            <strong> "Ana Ekrana Ekle"</strong> seçeneğini seçin.
          </p>
        </div>
      ) : (
        <div className="flex items-center gap-2 rounded-full border border-border bg-card shadow-2xl pl-4 pr-2 py-2" data-testid="install-banner">
          <Download size={16} className="text-primary" />
          <span className="text-sm font-medium">Uygulamayı yükle</span>
          <button onClick={install} data-testid="install-btn"
            className="ml-1 rounded-full bg-primary text-primary-foreground text-xs font-semibold px-3 py-1.5 hover:bg-primary/90 transition-colors">
            Yükle
          </button>
          <button onClick={dismiss} data-testid="install-close" className="text-muted-foreground hover:text-foreground p-1"><X size={15} /></button>
        </div>
      )}
    </div>
  );
}
